import { Component, Inject, Input, OnInit} from '@angular/core';
import { downgradeToAJSComponent } from 'ib-web-commons/utils';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AJSGiftCardsCommonsSessionStorageService, GiftCardsCommonsSessionStorageServiceType } from '@shared/services/upgrades/ib-gift-cards-commons-session-storage-bridge.service';
import { CommonModule } from '@angular/common';
import { UpgradeModule } from '@angular/upgrade/static';
import { NgReactModule } from '@src/app/react/ng-react.module';
import { FormsModule } from '@angular/forms';
import { EqualHeightDirective } from '@src/app/directives/standalone/equal-height/equal-height.directive';
import { IbGiftCardsThemeItemComponent } from '../ib-gift-cards-theme-item/ib-gift-cards-theme-item.component';
import { GiftCardsAppConstants } from '@src/app/shared/constants/ib-gift-cards-constants';
import { GiftCardThemesItem } from '@src/app/core/models/campaigns.model';



@Component({
    selector: 'ib-gift-cards-theme-component',
    standalone: true,
    imports: [CommonModule, UpgradeModule, TranslateModule, NgReactModule, FormsModule, ibGiftCardsThemeComponent, EqualHeightDirective, IbGiftCardsThemeItemComponent],
    templateUrl: './ib-gift-cards-theme.component.html',
    styleUrls: ['./ib-gift-cards-theme.scss']
})

export class ibGiftCardsThemeComponent implements OnInit { 
    @Input() model;
    @Input() show;
    
    specialCampaign: string;

    modelItemFirstRow: GiftCardThemesItem = GiftCardsAppConstants.CARD_THEMES_MODEL_FIRST_ROW;
    modelItemSecondRow: GiftCardThemesItem = GiftCardsAppConstants.CARD_THEMES_MODEL_SECOND_ROW;
    constructor (
        private translateService: TranslateService,
        @Inject(AJSGiftCardsCommonsSessionStorageService) private CommonsSessionStorageService: GiftCardsCommonsSessionStorageServiceType
    ) {
        
        if (this.modelItemFirstRow.length > 0) {
            this.modelItemFirstRow[0].theme = this.modelItemFirstRow[0].value;
        }
    }
    ngOnInit (): void {
        this.checkSpecialCampaignConfiguration();
    }

    checkSpecialCampaignConfiguration () {
        this.specialCampaign = this.CommonsSessionStorageService.get('specialCampaign');
        
        if(this.specialCampaign && this.isSpecialCampaignValid(this.specialCampaign)) {
            this.modelItemSecondRow[this.modelItemSecondRow.length -1] = GiftCardsAppConstants.CARD_THEMES_MODEL_SPECIAL_CAMPAIGN[this.specialCampaign];
        }
    }

    isSpecialCampaignValid (specialCampaign) {
        return GiftCardsAppConstants.CARD_THEMES_MODEL_SPECIAL_CAMPAIGN[specialCampaign] || false;
    }
    updateQuadrigam = () => {
        this.CommonsSessionStorageService.set('theme', this.model.theme);
    };
    onThemeChange (newTheme: string) {
        this.model.theme = newTheme;
    }
}

downgradeToAJSComponent('ibGiftCardsThemeComponent', {
    component: ibGiftCardsThemeComponent,
    inputs: []
}, 'ib-gift-cards-theme');


